/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@/api/fetchClient.js";
import type { PromptControllerGeneratePromptResponseWithFileMutationRequest, PromptControllerGeneratePromptResponseWithFileMutationResponse, PromptControllerGeneratePromptResponseWithFile400, PromptControllerGeneratePromptResponseWithFile401, PromptControllerGeneratePromptResponseWithFile404, PromptControllerGeneratePromptResponseWithFile409, PromptControllerGeneratePromptResponseWithFile500 } from "../types/PromptControllerGeneratePromptResponseWithFile.js";
import type { Client, RequestConfig, ResponseErrorConfig } from "@/api/fetchClient.js";
import { buildFormData } from "../.kubb/config.js";

function getPromptControllerGeneratePromptResponseWithFileUrl() {
  const res = { method: 'POST', url: `/api/prompt/file` as const }
  return res
}

/**
 * @description Generates a prompt response using multipart/form-data input, allowing file uploads. This endpoint is useful when the prompt generation requires additional file data. Returns immediately with task ID - poll /{promptRewardID}/status for completion.
 * @summary Generate Prompt Response with File
 * {@link /api/prompt/file}
 */
export async function promptControllerGeneratePromptResponseWithFile(data?: PromptControllerGeneratePromptResponseWithFileMutationRequest, config: Partial<RequestConfig<PromptControllerGeneratePromptResponseWithFileMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data
  const formData = buildFormData(requestData)
  const res = await request<PromptControllerGeneratePromptResponseWithFileMutationResponse, ResponseErrorConfig<PromptControllerGeneratePromptResponseWithFile400 | PromptControllerGeneratePromptResponseWithFile401 | PromptControllerGeneratePromptResponseWithFile404 | PromptControllerGeneratePromptResponseWithFile409 | PromptControllerGeneratePromptResponseWithFile500>, PromptControllerGeneratePromptResponseWithFileMutationRequest>({ method : "POST", url : getPromptControllerGeneratePromptResponseWithFileUrl().url.toString(), data : formData as FormData, ... requestConfig })
  return res.data
}